const autoNgTemplateLoaderTemplate1 = require('./engine-details-panel.html');

angular.module('portainer.docker').component('engineDetailsPanel', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    engine: '<',
  },
});
